/**
 * Collection page V2 — lightweight UI (description toggle, tab scroll, sort dropdown)
 */
(function () {
  'use strict';

  function initDescriptionToggle() {
    var toggle = document.getElementById('nnhDescToggle');
    var content = document.getElementById('nnhDescContent');
    if (!toggle || !content) return;

    toggle.addEventListener('click', function () {
      var expanded = content.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = toggle.querySelector('span');
      if (label) {
        label.textContent = expanded ? 'Show less' : 'Read more';
      }
    });
  }

  function initCalloutBody() {
    var callout = document.querySelector('.collection-page-v2__description-callout');
    if (!callout) return;

    var body = callout.querySelector('[data-nnh-callout-body]');
    if (!body) return;

    var headingEl = callout.querySelector('.collection-page-v2__description-callout-heading');
    if (headingEl) {
      body.innerHTML = (body.innerHTML || '').replace(/^\s*(?:<[^>]+>\s*)*Start with[\s\S]*?\.\s*/i, '');
    }
  }

  function initTabArrows() {
    var tabs = document.getElementById('collectionTabs');
    var prev = document.getElementById('tabsNavPrev');
    var next = document.getElementById('tabsNavNext');
    if (!tabs || !prev || !next) return;

    prev.addEventListener('click', function () {
      tabs.scrollBy({ left: -300, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      tabs.scrollBy({ left: 300, behavior: 'smooth' });
    });

    function syncArrows() {
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      var hide = maxScroll <= 0;
      prev.hidden = hide;
      next.hidden = hide;
      if (hide) return;
      prev.disabled = tabs.scrollLeft <= 0;
      next.disabled = tabs.scrollLeft >= maxScroll - 1;
    }

    tabs.addEventListener('scroll', syncArrows);
    window.addEventListener('resize', syncArrows);
    syncArrows();

    var activeTab = document.querySelector('.collection-tab--active');
    if (activeTab) {
      activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function initSortDropdown() {
    var selector = document.getElementById('collectionSortSelector');
    var dropdown = document.getElementById('collectionSortDropdown');
    var selectedLabel = document.getElementById('selectedSortOption');
    var options = document.querySelectorAll('.collection-sort__option');
    if (!selector || !dropdown) return;

    selector.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      dropdown.classList.toggle('collection-sort__dropdown--open');
      selector.classList.toggle('collection-sort__selector--open');
    });

    for (var i = 0; i < options.length; i++) {
      options[i].addEventListener('click', function (e) {
        e.stopPropagation();
        var sortUrl = this.getAttribute('data-sort-url');
        var sortName = this.getAttribute('data-sort-name');
        if (selectedLabel && sortName) {
          selectedLabel.textContent = sortName;
        }
        if (sortUrl) {
          window.location.href = sortUrl;
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (!selector.contains(e.target)) {
        dropdown.classList.remove('collection-sort__dropdown--open');
        selector.classList.remove('collection-sort__selector--open');
      }
    });
  }

  function init() {
    initCalloutBody();
    initDescriptionToggle();
    initTabArrows();
    initSortDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
